// Hiscore board of a loaded CS:S map. Like CS:S servers, records go by map name: everyone playing
// bhop_eazy_v2 with the standard zones shares one board. Zones a player drew themselves get a
// board of their own (`zones` is a fingerprint of them), since those runs aren't comparable.

/** Board key for map `name`, with the standard zones or with your own (`zones`). */
export function mapBoard(name: string, zones?: string): string {
  const id = name
    .toLowerCase()
    .replace(/[^\x21-\x7e]/g, '_')
    .slice(0, 120);
  return zones ? `m:${id}:${zones}` : `m:${id}`;
}
